import axios from "axios";
import { useState, useEffect } from "react";
import { APIErrorInterface, APIData } from "../models";

export const useIpAddress = (ipAddress: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState<APIData | null>(null);

  useEffect(() => {
    const getIpData = () => {
      setError("");
      setLoading(true);
      axios
        .get(
          `https://geo.ipify.org/api/v2/country,city?apiKey=${process.env.REACT_APP_API_KEY}&ipAddress=${ipAddress}`,
          {
            method: "GET",
          }
        )
        .then((res) => {
          setData(res.data);
        })
        .catch((err: APIErrorInterface) => {
          console.log(err);
          setError(err.response.data.messages);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    getIpData();
  }, [ipAddress]);

  return { loading, error, data };
};
